import {
  CLEAR_QUESTION,
  CLEAR_QUESTIONS,

  GET_QUESTION,
  GET_QUESTION_ERROR,
  GET_QUESTION_SUCCESS,

  GET_QUESTIONS,
  GET_QUESTIONS_ERROR,
  GET_QUESTIONS_SUCCESS,

  SAVE_QUESTION,
  SAVE_QUESTION_ERROR,
  SAVE_QUESTION_SUCCESS,

  ADD_QUESTION,
  ADD_QUESTION_ERROR,
  ADD_QUESTION_SUCCESS,

  MAIN_ANSWER,
  MAIN_ANSWER_ERROR,
  MAIN_ANSWER_SUCCESS,
} from './constants';

export default {
  [CLEAR_QUESTION](state) {
    state.question = {
    };
  },
  [CLEAR_QUESTIONS](state) {
    state.questions = [];
  },

  [GET_QUESTION](state) {
    state.question = false;
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_QUESTION_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_QUESTION_SUCCESS](state, payload) {
    state.question = payload;
    state.loading = false;
  },

  [GET_QUESTIONS](state) {
    state.questions = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_QUESTIONS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_QUESTIONS_SUCCESS](state, payload) {
    state.questions = payload;
    state.loading = false;
  },

  [SAVE_QUESTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_QUESTION_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_QUESTION_SUCCESS](state, payload) {
    state.question = payload;
    state.success = true;
    state.formLoading = false;
  },

  [ADD_QUESTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [ADD_QUESTION_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [ADD_QUESTION_SUCCESS](state, payload) {
    state.userQuestion = payload;
    state.success = true;
    state.formLoading = false;
  },

  [MAIN_ANSWER](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [MAIN_ANSWER_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [MAIN_ANSWER_SUCCESS](state, payload) {
    state.question = payload;
    state.success = true;
    state.formLoading = false;
  },
  // single object item mutation
  updateItem(state, payload) {
    state.question[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Forum/mutations.js